// lenis smooth scroll
// Initialize Lenis with an ignore setting to exclude scrollable sections
const lenis = new Lenis({
  smoothWheel: true,   // Smooth wheel behavior
  smoothTouch: false,  // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains('scroll-section')
});

// Update ScrollTrigger on Lenis scroll
lenis.on('scroll', ScrollTrigger.update);

// Integrate Lenis's request animation frame with GSAP's ticker
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

// Disable GSAP's lag smoothing to match Lenis
gsap.ticker.lagSmoothing(0);




// size chart start
function openSizeBox() {
    const sizeboxMenu = document.querySelector('.size-box');
    
    sizeboxMenu.classList.toggle("size-box-active");

    // Add event listener for scroll
    document.addEventListener('scroll', closeSizeBoxOnScroll);
}

function closeSizeBoxOnScroll() {
    const sizeboxMenu = document.querySelector('.size-box');
    const relatedProducts = document.querySelector('.related-products');

    const sizeboxPosition = sizeboxMenu.getBoundingClientRect();
    const relatedProductsPosition = relatedProducts.getBoundingClientRect();

    if (sizeboxPosition.bottom >= relatedProductsPosition.top) {
        sizeboxMenu.classList.remove("size-box-active");
        document.removeEventListener('scroll', closeSizeBoxOnScroll);
    }
}



document.addEventListener('DOMContentLoaded', function() {
    var icon2 = document.querySelector('#icon3');
    var mobileMenu = document.querySelector('.mobile-menu');
    
    icon2.onclick = function() {
        mobileMenu.classList.toggle('open');
      this.classList.toggle('open');
    };
});




// search drawer
// var searchHere = document.querySelector(".searchHere1");
// var container = document.querySelector(".container-menu-d");
// var eclips = document.querySelector(".eclips");

// var searchButton = true;

// searchHere.addEventListener('click', () => {
//     if (searchButton) {
//         container.style.top = "0";
//         document.body.classList.add('no-scroll'); // Add no-scroll class to body
//         searchButton = !searchButton;
//     } else {
//         container.style.top = "-100vh";
//         document.body.classList.remove('no-scroll'); // Remove no-scroll class from body
//         searchButton = !searchButton;
//     }
// });
// ---------------------------------------------------

// ----xbutton also able to close---

var searchLink = document.getElementById("searchLink");
var closeLink = document.getElementById("closeLink");
var container = document.querySelector(".container-menu-d");
var eclips = document.querySelector(".eclips");
var xsvg = document.querySelector(".xsvg"); // Select the .xsvg element

var searchButton = true;

searchLink.addEventListener('click', () => {
    if (searchButton) {
        container.style.top = "0";
        document.body.classList.add('no-scroll'); // Add no-scroll class to body
        
        // Hide "search here" and show "close"
        searchLink.style.display = "none";
        closeLink.style.display = "flex";

        searchButton = false;
    }
});

closeLink.addEventListener('click', () => {
    closeMenu(); 
});

xsvg.addEventListener('click', () => {
    closeMenu(); 
});

function closeMenu() {
    container.style.top = "-100vh";
    document.body.classList.remove('no-scroll'); // Remove no-scroll class from body
    
    // Show "search here" and hide "close"
    searchLink.style.display = "flex";
    closeLink.style.display = "none";

    searchButton = true;
}


// ----xbutton also able to close---

// ----- color theme switch -------


// // Function to set the theme
// function setTheme(theme) {
//   document.documentElement.setAttribute("data-theme", theme);
//   localStorage.setItem("theme", theme);
// }

// // Function to toggle the theme
// function switchTheme(e) {
//   const theme = e.target.checked ? "dark" : "light";
//   setTheme(theme);
// }

// // Event listeners for toggle switches
// // const toggleSwitch1 = document.querySelector(".toggle-button1");
// const toggleSwitch2 = document.querySelector(".toggle-button");

// // toggleSwitch1.addEventListener("change", switchTheme);
// toggleSwitch2.addEventListener("change", switchTheme);

// // Set the initial theme based on user preference or default to light
// const currentTheme = localStorage.getItem("theme") || "light";
// setTheme(currentTheme);

// // Check and set toggle switch based on the initial theme
// // toggleSwitch1.checked = currentTheme === "dark";
// toggleSwitch2.checked = currentTheme === "dark";
// --------------------------------------------------------
function setTheme(theme) {
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem("theme", theme);
}

// Function to toggle the theme
function switchTheme(e) {
  const theme = e.target.checked ? "dark" : "light";
  setTheme(theme);
}

// Event listener for toggle switch
const toggleSwitch2 = document.querySelector(".toggle-button");
toggleSwitch2.addEventListener("change", switchTheme);

// Set the initial theme based on user preference or default to light
const currentTheme = localStorage.getItem("theme") || "light";
setTheme(currentTheme);

// Check and set toggle switch based on the initial theme
toggleSwitch2.checked = currentTheme === "dark";



// ----- color theme switch -------



// hero popup start

// Function to show the overlay
// function showOverlay() {
//     if (!sessionStorage.getItem('overlayShown')) {
//         // Show the overlay
//         document.getElementById('overlay').style.display = 'flex';
        
//         // Add class to body to stop scrolling
//         document.body.classList.add('no-scroll');

//         // Set a flag in sessionStorage to indicate that the overlay has been shown
//         sessionStorage.setItem('overlayShown', 'true');
//     }
// }

// // Function to hide the overlay
// function hideOverlay() {
//     document.getElementById('overlay').style.display = 'none';
//     document.body.classList.remove('no-scroll');
// }

// // Close the overlay if clicked on close icon
// document.querySelector('.hero-popup-close').addEventListener('click', hideOverlay);

// // Close the overlay if clicked outside the popup container
// document.getElementById('overlay').addEventListener('click', (event) => {
//     if (event.target === document.getElementById('overlay')) {   
//         hideOverlay();
//     }
// });

// // Close the overlay on pressing 'Escape' key
// document.addEventListener('keydown', (event) => {
//     if (event.key === 'Escape') {
//         hideOverlay();
//     }
// });

// // Show the overlay when the page is loaded
// document.addEventListener('DOMContentLoaded', (event) => {
//     showOverlay();
// });


// hero popup end 


// ----- dev02------

// ------ desktop t-dhirt and cap menu-------
document.addEventListener("DOMContentLoaded", function () {
    const oversizedLink = document.querySelector(".oversize-link");
    const regularLink = document.querySelector(".regular-link");
    const oversizeData = document.querySelector(".oversize-data");
    const regularData = document.querySelector(".regular-data");

    // By default, .oversize-data is visible
    oversizeData.style.display = "flex";
    regularData.style.display = "none";

    // Set the initial active state for the oversized link
    oversizedLink.classList.add("active");
    regularLink.classList.remove("active");

    // When hovering over "Regular Fit"
    regularLink.addEventListener("mouseenter", function () {
        oversizeData.style.display = "none";
        regularData.style.display = "flex";

        // Set active class on regular link
        regularLink.classList.add("active");
        oversizedLink.classList.remove("active");
    });

    // When hovering over "Oversized Unisex"
    oversizedLink.addEventListener("mouseenter", function () {
        regularData.style.display = "none";
        oversizeData.style.display = "flex";

        // Set active class on oversized link
        oversizedLink.classList.add("active");
        regularLink.classList.remove("active");
    });
});

// ------ desktop t-dhirt and cap menu-------



// ----------- mobile tshirt and cap menu-----

function toggleTshirtData() {
    const tshirtData = document.querySelector(".tshirst-data");
    tshirtData.classList.toggle("show");
}
// ----
function toggloverData() {
    const overData = document.querySelector(".oversize-datam");
    overData.classList.toggle("show");
}
// ----
function toggregularData() {
    const regularData = document.querySelector(".regular-datam");
    regularData.classList.toggle("show");
}
// -------
function toggleCapm() {
    const cpData = document.querySelector(".cap-datam");
    cpData.classList.toggle("show");
}

// ----------- mobile tshirt and cap menu-----



// -------- for transperant header on hero section-----
document.addEventListener("DOMContentLoaded", function() {
    const heroSection = document.querySelector('.n9_hero2_section');
    const header = document.querySelector('.n9-header');

    if (heroSection && header) {
        header.style.background = 'transparent'; 
    }
});
// -------- for transperant header on hero section-----


// ------------- one time popup in session----

// document.addEventListener('DOMContentLoaded', function () {
//     const heroPopup = document.getElementById('overlay');
//     const closeButton = document.querySelector('.hero-popup-close');

//     // Check if the popup has been closed in the current session
//     const isPopupClosed = sessionStorage.getItem('isPopupClosed');

//     // If the popup hasn't been closed, show it
//     if (!isPopupClosed) {
//         heroPopup.style.display = 'flex'; // Show the popup
//     }

//     closeButton.addEventListener('click', function() {
//         heroPopup.style.display = 'none'; // Hide the popup
//         sessionStorage.setItem('isPopupClosed', 'true'); // Mark as closed for the session
//     });
// });


// ------------- one time popup in session----

// ---------- remove search and theme change in product view----

document.addEventListener('DOMContentLoaded', () => {
    if (window.location.href.includes('/products/') && window.innerWidth <= 750) {
        document.querySelector('.hero-search')?.style.setProperty('display', 'none');
        document.querySelector('.toggle-container')?.style.setProperty('display', 'none');
    }
});



// ---------- remove search and theme change in product view----

// ----- dev02------

function openTab(event, tabName) {
  // Hide all tab content with max-height transition
  const allTabs = document.querySelectorAll('.caps-tab-content');
  allTabs.forEach(tab => {
    tab.style.maxHeight = '0'; // Collapse the tab content
  });

  // Remove the active class from all tabs
  const allTabButtons = document.querySelectorAll('.caps-tab');
  allTabButtons.forEach(button => button.classList.remove('active'));

  // Show the clicked tab's content
  const currentTab = document.getElementById(tabName);
  currentTab.style.maxHeight = currentTab.scrollHeight + 'px'; // Set max-height to content's height

  // Add the active class to the clicked tab button
  event.currentTarget.classList.add('active');
}

// Set default tab (Tab 1) to be open on page load
document.addEventListener("DOMContentLoaded", () => {
  const firstTab = document.querySelector(".caps-tab");
  if (firstTab) {
    firstTab.click(); // Simulate click on the first tab
  }
});


// ----- try ------


// ----- try ------


// document.addEventListener("DOMContentLoaded", function () {
//   const slider = document.querySelector(".cap_banner_left");
//   const slides = slider.querySelectorAll("li");
//   const slideWidth = slides[0].offsetWidth;

//   // Clone the first and last few slides for seamless looping
//   slides.forEach((slide, index) => {
//     if (index < 3) {
//       const clone = slide.cloneNode(true);
//       slider.appendChild(clone);
//     }
//     if (index >= slides.length - 3) {
//       const clone = slide.cloneNode(true);
//       slider.insertBefore(clone, slider.firstChild);
//     }
//   });

//   // Adjust the slider scroll position to the "real" start
//   const initialScrollPosition = slides.length * slideWidth;
//   slider.scrollLeft = initialScrollPosition;

//   // Infinite scrolling logic
//   let isScrolling = false;

//   slider.addEventListener("scroll", () => {
//     if (isScrolling) return; // Prevent nested scroll events

//     const maxScrollLeft = slider.scrollWidth - slider.offsetWidth;

//     // Reset to the start of the loop if scrolled past the end
//     if (slider.scrollLeft >= maxScrollLeft) {
//       isScrolling = true;
//       slider.scrollLeft = initialScrollPosition;
//       isScrolling = false;
//     }

//     // Reset to the end of the loop if scrolled before the start
//     if (slider.scrollLeft <= 0) {
//       isScrolling = true;
//       slider.scrollLeft = maxScrollLeft - initialScrollPosition;
//       isScrolling = false;
//     }
//   });

//   // Auto-slide logic for mobile only
//   const autoSlideSpeed = 1; // Slow down by decreasing speed (pixels per frame)
//   const autoSlideInterval = 80; // Increase the interval for slower updates
//   let autoSlideTimer;

//   function startAutoSlide() {
//     autoSlideTimer = setInterval(() => {
//       if (!isScrolling) {
//         slider.scrollLeft += autoSlideSpeed;
//       }
//     }, autoSlideInterval);
//   }

//   function stopAutoSlide() {
//     clearInterval(autoSlideTimer);
//   }

//   // Function to handle mobile-only logic
//   function handleAutoSlide() {
//     const isMobile = window.matchMedia("(max-width: 768px)").matches; // Adjust breakpoint as needed
//     if (isMobile) {
//       startAutoSlide();
//       slider.addEventListener("mouseenter", stopAutoSlide); // Pause on hover
//       slider.addEventListener("mouseleave", startAutoSlide); // Resume on mouse leave
//     } else {
//       stopAutoSlide();
//       slider.removeEventListener("mouseenter", stopAutoSlide);
//       slider.removeEventListener("mouseleave", startAutoSlide);
//     }
//   }

//   // Initialize on load
//   handleAutoSlide();

//   // Re-check on window resize
//   window.addEventListener("resize", handleAutoSlide);
// });

